module.exports = __webpack_public_path__ + "static/media/dark_circle.5d0eb4dc.svg";